module.exports = __webpack_public_path__ + "img/20.d2872f75.svg";